import styles from './SubmitBtn.module.css'
function SubmitBtn ({text, className, hideLabel, attachmentStyle = false}) {

    let classes = `${styles.btn}${attachmentStyle ? ` ${styles.attachmentBtn}` : ''}`;
    classes += className !== undefined ? ` ${className}` : '';
    return (
        <div className={styles.form_control}>
            {hideLabel ? (<></>) : (<label>&nbsp;</label>)}
            <button className={`${classes}`}>{text}</button>
        </div>
    )
}

export default SubmitBtn
